import { Component, useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Ticker from "./components/Ticker";
import { TrustStrip } from "./components/Compliance";
import About from "./components/About";
import MeetTheDev from "./components/MeetTheDev";
import WhyBald from "./components/WhyBald";
import TokenInfo from "./components/TokenInfo";
import BuySection from "./components/BuySection";
import BuyBurn from "./components/BuyBurn";
import GivesBack from "./components/GivesBack";
import Roadmap from "./components/Roadmap";
import Community from "./components/Community";
import MemeContest from "./components/MemeContest";
import Gallery from "./components/Gallery";
import Milestones from "./components/Milestones";
import Faq from "./components/Faq";
import FinalCta from "./components/FinalCta";
import Footer from "./components/Footer";

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    componentDidCatch(err) {
        console.error(err);
    }
    render() {
        if (this.state.hasError) {
            return (
                <div className="flex min-h-screen items-center justify-center bg-[#04060D] p-8 text-center">
                    <p className="font-mono text-sm text-slate-400">Something broke. Stay bald — refresh the page.</p>
                </div>
            );
        }
        return this.props.children;
    }
}

function Landing() {
    useEffect(() => {
        const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        if (reduce) return;
        const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
        window.__lenis = lenis;
        let raf;
        const loop = (t) => {
            lenis.raf(t);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            delete window.__lenis;
        };
    }, []);

    return (
        <div className="grain relative min-h-screen overflow-x-clip bg-[#04060D] text-slate-100">
            <Navbar />
            <main>
                <Hero />
                <TrustStrip />
                <Ticker />
                <About />
                <MeetTheDev />
                <WhyBald />
                <TokenInfo />
                <BuySection />
                <BuyBurn />
                <GivesBack />
                <Roadmap />
                <Community />
                <MemeContest />
                <Gallery />
                <Milestones />
                <Faq />
                <FinalCta />
            </main>
            <Footer />
            <Toaster
                theme="dark"
                position="bottom-center"
                toastOptions={{
                    style: {
                        background: "#0A0E1A",
                        border: "1px solid rgba(0,240,255,0.3)",
                        color: "#F8FAFC",
                        fontFamily: "'JetBrains Mono', monospace",
                    },
                }}
            />
        </div>
    );
}

export default function App() {
    return (
        <ErrorBoundary>
            <Landing />
        </ErrorBoundary>
    );
}
